<mat-card style="border-color: #5775a8;">
  <mat-card-header>

    <div class="flex flex-col w-full">
      <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8;">
        <!-- <mat-icon style="color: white;">settings</mat-icon> -->
        <span style="font-size: large; color: white;padding: 17px;">
          Site Visit
        </span>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col w-full">
      <br/>
      <span style="font-size: smaller;">
        This page contains information about the initial site visits, follow-up visits, post remediation plans and
        inspections related to <strong>{{businessName}}</strong>
      </span>

      <div class="row" *ngIf="complaintId == null || complaintId == 0">
        <span style="font-size: small; color: grey;padding-left: 20px;">
          You cannot edit correspondence in this view. Click on links to complaints to edit correspondence for that
          complaint.
        </span>
      </div>
      <!-- Exempt Business Notification -->
      <div *ngIf="localSite.businessExempt == true">
        <span>&nbsp;</span>
        <span style="color:red;">This is an Exempt Business.</span>
      </div>
      <!-- Complaint Details Panel-->
      <div class="panel" *ngIf="complaint != null">
        <br/>
        <div class="row">
          <div class="col-md-3">
            <b>Complaint Submitted Date</b>
          </div>
          <div class="col-md-9">
            {{complaint.complaintDate}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b>Submitted Complaint Text</b>
          </div>
          <div class="col-md-9">
            {{complaint.complaintComments}}
          </div>
        </div>
      </div>

      <!-- <ul class="nav nav-tabs">
      <li class="@if (siteVisitSelectedTab == " sitevisit") {@siteVisitActiveTabClass }">
        <a data-toggle="tab" href="#initialSiteVisit">Initial Site Visit <span class="text-muted">(Form 1)</span></a>
      </li>
      <li class="@if (siteVisitSelectedTab == " followupvisit") {@siteVisitActiveTabClass }"><a data-toggle="tab"
          href="#followUpSiteVisit">Follow-up Visit <span class="text-muted">(Form 2)</span></a></li>
      <li class="@if (siteVisitSelectedTab == " postremdiationvisit") {@siteVisitActiveTabClass }"><a data-toggle="tab"
          href="#remediationSiteVisit">Post Remediation Plan Visit <span class="text-muted">(Form 3)</span></a></li>
    </ul> -->


      <mat-tab-group dynamicHeight [(selectedIndex)]="currentTab" (selectedTabChange)="tab()">

        <mat-tab label="Initial Site Visit (Form 1)">
          <shared-initialSiteVisit [parentPanel]="parentPanel"></shared-initialSiteVisit>
        </mat-tab>

        <mat-tab label="Follow-up Visit (Form 2)">
          <shared-followupSiteVisit [parentPanel]="parentPanel"></shared-followupSiteVisit>
        </mat-tab>

        <mat-tab label="Post Remediation Plan Visit (Form 3)">
          <shared-postRemediationVisit [parentPanel]="parentPanel"></shared-postRemediationVisit>
        </mat-tab>

      </mat-tab-group>
    </div>

  </mat-card-content>

</mat-card>